import { InjectionToken } from "@angular/core";
import { IInstalledAppsOverviewStateService } from "./i-installed-apps-overview-state-service";

export const installedAppsOverviewStateServiceInjectionToken: InjectionToken<IInstalledAppsOverviewStateService> = new InjectionToken<IInstalledAppsOverviewStateService>("digital-signage.user-dashboard.dashboard-web.InstalledAppsOverviewStateService");
